import React from 'react';
// --- Ícones atualizados para lucide-react para consistência ---
import { 
    Building, Mail, Phone, MapPin, CheckCircle, Edit, Trash2, Hash
} from 'lucide-react';

const regimes = [
  "1 - Simples Nacional",
  "2 - Simples Nacional (Excesso Sublimite)",
  "3 - Regime Normal",
  "4 - MEI"
];

export default function CardEmpresa({
  empresa,
  onEditar,
  onExcluir,
  onEnviarCertificado,
}) {

  const formatarCNPJ = (cnpj) => {
    if (!cnpj) return 'Não informado';
    return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
  };

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md flex flex-col transition hover:shadow-xl hover:-translate-y-1">
      {/* Cabeçalho do Card */}
      <div className="p-4 flex justify-between items-start">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-blue-100 dark:bg-blue-900/50 rounded-md">
            <Building className="w-6 h-6 text-blue-600 dark:text-blue-400" />
          </div>
          <div>
            <h3 className="font-bold text-lg text-gray-800 dark:text-gray-100">{empresa.nomeFantasia}</h3>
            <p className="text-sm text-gray-500 dark:text-gray-400">{empresa.razaoSocial}</p>
          </div>
        </div>
      </div>

      {/* Corpo do Card com as Informações */}
      <div className="p-4 space-y-3 text-sm flex-grow border-t border-b dark:border-gray-700">
        <InfoItem icone={Hash} label="CNPJ:" texto={formatarCNPJ(empresa.cnpj)} />
        <InfoItem icone={Hash} label="Inscrição Municipal:" texto={empresa.inscricaoMunicipal || 'Não informada'} />
        <InfoItem icone={Mail} label="E-mail:" texto={empresa.email || 'Não informado'} />
        <InfoItem icone={Phone} label="Telefone:" texto={empresa.telefone || 'Não informado'} />
        <InfoItem icone={MapPin} label="Endereço:" texto={`${empresa.endereco || ''}, ${empresa.numero || ''} - ${empresa.cidade || ''}/${empresa.estado || ''}`} />
        
        <div className="pt-2">
          <button 
            onClick={onEnviarCertificado}
            className={`w-full text-center px-3 py-2 rounded-md text-xs font-bold transition-colors ${
                empresa.certificadoStatus === 'ok' 
                ? 'bg-green-100 text-green-800 dark:bg-green-900/50 dark:text-green-300' 
                : 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/50 dark:text-yellow-400 hover:bg-yellow-200'
            }`}
          >
            <div className="flex items-center justify-center gap-2">
               <CheckCircle size={14} />
               <span>{empresa.certificadoStatus === 'ok' ? 'Certificado OK' : 'Enviar Certificado'}</span>
            </div>
          </button>
        </div>
      </div>

      {/* Rodapé com os Botões de Ação */}
      <div className="p-3 flex items-center justify-end gap-2 bg-gray-50 dark:bg-gray-800/50 rounded-b-xl">
        {/* --- CORREÇÃO: O botão agora é "Editar" и chama onEditar --- */}
        <button 
          onClick={onEditar} 
          className="flex items-center gap-2 px-4 py-2 text-sm font-semibold text-blue-700 bg-blue-100 rounded-md hover:bg-blue-200 dark:bg-blue-900/50 dark:text-blue-300 dark:hover:bg-blue-900"
        >
          <Edit size={14} /> Editar
        </button>
        <button 
          onClick={onExcluir} 
          className="flex items-center gap-2 px-4 py-2 text-sm font-semibold text-red-700 bg-red-100 rounded-md hover:bg-red-200 dark:bg-red-900/50 dark:text-red-300 dark:hover:bg-red-900"
        >
          <Trash2 size={14} /> Excluir
        </button>
      </div>
    </div>
  );
}

// Componente auxiliar para os itens de informação
const InfoItem = ({ icone: Icone, label, texto }) => (
    <div className="flex items-start gap-3 text-gray-600 dark:text-gray-300">
        <Icone size={16} className="text-gray-400 mt-0.5 flex-shrink-0" />
        <div>
            <span className="font-semibold text-gray-700 dark:text-gray-200">{label}</span>
            <span className="ml-1">{texto}</span>
        </div>
    </div>
);
